<app-common-modal-wrapper
  [header]="labels.header"
  (close)="close()"
  (submitModal)="submit()"
  [formGroup]="form"
>
  <div class="wrapper">
    <app-autocomplete
      formControlName="class"
      [label]="labels.class"
      [options]="shareTypeOptions"
      [valuePrimitive]="true"
      [allowTypeAnyValue]="true"
      [customErrors]="shareClassCustomErrors"
    />

    <app-input-number
      label="Paid"
      formControlName="paidAmount"
    />

    <app-input-number
      label="Unpaid"
      formControlName="unpaidAmount"
    />

    <app-input
      [label]="labels.customName"
      formControlName="name"
    />

    <app-input
      [label]="labels.identifier"
      formControlName="identifier"
    />
  </div>

  @if (showValidationError) {
    <app-validation-error
      [control]="form"
      [customErrors]="{existingSecurityType: 'This security type already exists.'}"
    />
  }
</app-common-modal-wrapper>
